/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import React from "react"

// You can delete this file if you're not using it
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}

export const onRenderBody = ({ setPostBodyComponents }) => {
  setPostBodyComponents([
    <div key="fb-root" id="fb-root" />,
    <script
      key="fb-sdk"
      async
      defer
      src="https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v12.0"
    />,
  ])
}
